import { z } from 'zod';
import { createDateTimeSchema, Validation } from '@mews/framework';
import { FilterValueKey } from './types';

export const commonFilterSchema = z
    .object({
        [FilterValueKey.startDate]: Validation.DateTime.Utc,
        [FilterValueKey.endDate]: Validation.DateTime.Utc,
    })
    .extend<{}>(createDateTimeSchema({ fieldName: FilterValueKey.startDate }))
    .extend<{}>(createDateTimeSchema({ fieldName: FilterValueKey.endDate }));

export const commontUrlSchema = commonFilterSchema
    .pick({ [FilterValueKey.startDate]: true, [FilterValueKey.endDate]: true })
    .partial();

export type CommonFilterValues = z.infer<typeof commonFilterSchema>;
